import React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, Input, Row, Col, Space, Table } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import Select from "react-select";
import { set } from "date-fns";
import { colors } from "../../theme/colors";

const CoOrderProducts = (props) => {
  const { data, handleOrderProducts, numProds, ordTot, isEdit, isEditable } =
    props;
  const [productsData, setProductsData] = React.useState([]);
  const [productOptions, setProductOptions] = React.useState([]);
  const [oldData, setOldData] = React.useState([]);

  React.useEffect(() => {
    console.log("Product Data: ", data);
    // console.log("Product Columns: ", columns);
    setProductsData(data);
    let options = [];
    let tempData = [];
    data.map((product) => {
      const obj = {
        value: product.ProductCode,
        label: product.ProductCode,
        Cost: product.Price,
        isDisabled: false,
        // key: product.ID,
        ...product,
      };
      options.push(obj);
      tempData.push({
        ...product,
        Cost: product.Price,
      });
    });
    setOldData(tempData);
    console.log("Product Options: ", options);
    setProductOptions(options);
    // setProductsColumns(columns);
  }, []);

  const [orderTotal, setOrderTotal] = React.useState(ordTot ? ordTot : 0);
  const [numberOfProducts, setNumberOfProducts] = React.useState(
    numProds ? numProds : 0
  );
  const [selectedData, setSelectedData] = useState([
    {
      key: 1,
      ProductCode: "",
      ProductName: "",
      Cost: "",
      Quantity: "",
      ProductTotal: "",
    },
  ]);
  const addRow = () => {
    const newKey = selectedData.length
      ? selectedData[selectedData.length - 1].key + 1
      : 1;
    const newRow = {
      key: newKey,
      ProductCode: "",
      ProductName: "",
      Cost: "",
      Quantity: "",
      ProductTotal: "",
    };
    setSelectedData([...selectedData, newRow]);
  };

  const deleteRow = (key) => {
    // on delete, enable the option in the dropdown
    const selectedProduct = selectedData.find((row) => row.key === key);
    const newOptions = productOptions.map((option) =>
      option.value === selectedProduct.ProductCode
        ? { ...option, isDisabled: false }
        : option
    );
    setProductOptions(newOptions);
    let curQty = selectedData.find((row) => row.key === key).Quantity;
    let curTotal = selectedData.find((row) => row.key === key).ProductTotal;
    setNumberOfProducts(Number(numberOfProducts) - Number(curQty));
    setOrderTotal(Number(orderTotal) - Number(curTotal));
    setSelectedData(selectedData.filter((row) => row.key !== key));
  };

  const handleSelectChange = (value, key) => {
    // console.log("Selected Value: ", value.value);
    const newData = selectedData.map((row) =>
      row.key === key
        ? {
            ...row,
            ProductCode: value.value,
            ProductName: value.ProductName,
            Cost: value.Cost,
            Quantity: 1,
            // Quantity: value.Quantity,
            ProductTotal: Number(value.Cost).toString(),
          }
        : row
    );
    // disable this option from the dropdown
    let newOptions = [];
    if (newData.length === 1) {
      newOptions = productOptions.map((option) =>
        option.value === value.value
          ? { ...option, isDisabled: true }
          : { ...option, isDisabled: false }
      );
    } else {
      newOptions = productOptions.map((option) =>
        option.value === value.value ? { ...option, isDisabled: true } : option
      );
    }
    setProductOptions(newOptions);
    setSelectedData(newData);
    // setOrderTotal(Number(orderTotal) + Number(value.Cost));
    // setNumberOfProducts(Number(numberOfProducts) + 1);
    let tempTotal = 0,
      nop = 0;
    for (let i = 0; i < newData.length; i++) {
      const selectedProduct = productOptions.find(
        (option) => option.value === newData[i].ProductCode
      );
      console.log("Handle QTY Product Options: ", selectedProduct);
      newData[i].Price = selectedProduct.Price;
      newData[i].StandardPrice = selectedProduct.Price;
      newData[i].ProductID = selectedProduct.ProductID;
      newData[i].ID = selectedProduct.ProductID;
      newData[i].ManufacturerID = selectedProduct.ManufacturerID;
      tempTotal += Number(newData[i].ProductTotal);
      nop += Number(newData[i].Quantity);
    }
    setOrderTotal(Number(tempTotal));
    setNumberOfProducts(Number(nop));
    handleOrderProducts(
      newData,
      Number(orderTotal) + Number(value.Cost),
      Number(numberOfProducts) + 1
    );
  };

  const handleQuantityChange = (e, key, column) => {
    const newData = selectedData.map((row) =>
      row.key === key
        ? {
            ...row,
            [column]: e.target.value,
            ProductTotal: (
              Number(row.Cost) * Number(e.target.value)
            ).toString(),
          }
        : row
    );
    let total = 0,
      qty = 0;
    newData.map((row) => {
      total += Number(row.ProductTotal);
      qty += Number(row.Quantity);
    });
    setNumberOfProducts(Number(qty));
    setOrderTotal(Number(total));
    setSelectedData(newData);

    // // add Price, ProductID, ManufacturerID to the selectedData
    // newData.map((row) => {
    for (let i = 0; i < newData.length; i++) {
      const selectedProduct = productOptions.find(
        (option) => option.value === newData[i].ProductCode
      );
      console.log("Handle QTY Product Options: ", selectedProduct);
      newData[i].Price = selectedProduct.Price;
      newData[i].StandardPrice = selectedProduct.Price;
      newData[i].ProductID = selectedProduct.ProductID;
      newData[i].ID = selectedProduct.ProductID;
      newData[i].ManufacturerID = selectedProduct.ManufacturerID;
    }
    console.log("New Data: ", newData);
    handleOrderProducts(newData, Number(total), Number(qty));
  };

  const handleInputChange = (e, key, column) => {
    const newData = selectedData.map((row) =>
      row.key === key ? { ...row, [column]: e.target.value } : row
    );
    setSelectedData(newData);
  };

  const columns = [
    {
      title: "Product Code",
      dataIndex: "ProductCode",
      width: "20%",
      render: (_, record) => (
        <Select
          value={{ label: record.ProductCode, value: record.ProductCode }}
          onChange={(value) => handleSelectChange(value, record.key)}
          style={{ width: "100%" }}
          options={productOptions}
          isDisabled={!isEditable}
        >
          {/* {productOptions.map((option) => (
            <Option value={option.value}>{option.label}</Option>
          ))} */}
        </Select>
      ),
    },
    {
      title: "Product Name",
      dataIndex: "ProductName",
      width: "20%",
      render: (_, record) => (
        <Input
          value={record.ProductName}
          // onChange={e => handleInputChange(e, record.key, 'ProductName')}
          disabled={true}
        />
      ),
    },
    {
      title: "Cost",
      dataIndex: "Cost",
      width: "15%",
      render: (_, record) => (
        <Input
          value={record.Cost}
          // onChange={e => handleInputChange(e, record.key, 'Cost')}
          disabled={true}
        />
      ),
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      width: "15%",
      render: (_, record) => (
        <Input
          value={record.Quantity}
          onChange={(e) => handleQuantityChange(e, record.key, "Quantity")}
          disabled={!isEditable}
        />
      ),
    },
    {
      title: "Product Total",
      dataIndex: "ProductTotal",
      width: "20%",
      render: (_, record) => (
        <Input
          value={record.ProductTotal}
          // onChange={e => handleInputChange(e, record.key, 'ProductTotal')}
          disabled={true}
        />
      ),
    },
    {
      title: "",
      dataIndex: "actions",
      width: "10%",
      render: (_, record) => (
        <Space>
          <Button
            type="danger"
            icon={isEditable ? <DeleteOutlined /> : <></>}
            onClick={() => deleteRow(record.key)}
            disabled={!isEditable}
          />
        </Space>
      ),
    },
  ];

  const components = {
    header: {
      cell: ({ style, ...restProps }) => (
        <th
          {...restProps}
          style={{
            ...style,
            backgroundColor: "#eee",
            color: "#000",
          }}
        />
      ),
    },
    body: {
      cell: ({ style, ...restProps }) => (
        <td
          {...restProps}
          style={{
            ...style,
            backgroundColor: "#eee",
            color: "#000",
          }}
        />
      ),
    },
  };

  return (
    <div>
      {/* <Row gutter={16}>
        <Col span={6} style={{ width: '100%' }}>
          <label className="form-label">Product Code</label>
          <Select
            style={{ width: '100%' }}
            // defaultValue="WP016"
            options={productOptions}
            onChange={(selectedOption) => {
              const obj = {
                ProductCode: selectedOption.value,
                ProductName: selectedOption.ProductName,
                Cost: selectedOption.Cost,
                Quantity: 0,
                ProductTotal: 0
              }
              setSelectedData([...selectedData, obj]);
            }}
          />
        </Col>
        <Col span={6} style={{ width: '100%' }}>
          <label className="form-label">Product Name</label>
          <Input
            name="PONumber"
          // value={formik.values.PONumber}
          // onChange={(event) => formik.setFieldValue('PONumber', event.target.value)}
          // defaultValue={formik.values.PONumber}
          />
        </Col>
        <Col span={3} style={{ width: '100%' }}>
          <label className="form-label">Cost</label>
          <Input
            value="$2,000"
            disabled={true}
          />
        </Col>
        <Col span={3} style={{ width: '100%' }}>
          <label className="form-label">Quantity</label>
          <Input value="3" />
        </Col>
        <Col span={3}>
          <label className="form-label">Product Total</label>
          <Input value="$6,000" disabled={true} />
        </Col>
      </Row> */}
      <Table
        columns={columns}
        dataSource={isEdit ? oldData : selectedData}
        pagination={false}
        components={components}
        rowKey="key"
        bordered={false}
      />
      {isEditable && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={addRow}
          style={{ marginTop: 16, background: colors["primaryColor"] }}
        >
          Add New Row
        </Button>
      )}
      <Row
        gutter={16}
        style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}
      >
        <Col span={3}>
          <Form.Item label="Number of Products">
            <Input value={`${numberOfProducts}`} disabled={true} />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item label="Order Total">
            <Input value={`$${orderTotal}`} disabled={true} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default CoOrderProducts;
